import React from 'react';
import { Info } from 'lucide-react';

/**
 * Small info banner explaining that on campaign-level pages GA4 metrics are
 * filtered to platform = web when the brand has Adjust connected. App-level
 * traffic (iOS / Android) is attributed via Adjust in the adjacent columns,
 * so showing all platforms here would double-count sessions/users/revenue.
 *
 * The view-layer does this automatically: if the brand has no Adjust data,
 * all platforms are shown; otherwise only web is shown.
 */
export default function Ga4WebOnlyNote({ className = '' }) {
  return (
    <div
      className={`flex items-start gap-2.5 rounded-xl border border-blue-100 bg-blue-50/70 px-4 py-2.5 text-xs text-blue-900 ${className}`}
    >
      <Info className="w-4 h-4 mt-0.5 flex-shrink-0 text-blue-500" />
      <div className="leading-relaxed">
        <span className="font-semibold">GA4 metrics shown are web-only</span>{' '}
        when this brand has Adjust connected. App traffic (iOS / Android) is
        attributed by Adjust in the adjacent columns (installs, sessions,
        purchase events, revenue) to prevent double counting. Brands without
        Adjust continue to show all platforms in GA4.
      </div>
    </div>
  );
}
